<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <v-btn icon
             v-on="{ ...on }"
             @click.stop.prevent="emitChange">
        <v-icon :color="iconColor">mdi-filter-outline</v-icon>
      </v-btn>
    </template>
    <span>Filtrar por mensagens padrões</span>
  </v-tooltip>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('listagemMensagens', ['hasCustomFilters']),
    iconColor() {
      return this.hasCustomFilters ? 'primary' : '';
    },
    onlyPadrao: {
      get() {
        return this.$store.getters['listagemMensagens/onlyPadrao'];
      },
      set(onlyPadrao) {
        this.$store.dispatch('listagemMensagens/onlyPadrao', onlyPadrao);
      },
    },
  },
  methods: {
    emitChange() {
      this.onlyPadrao = !this.onlyPadrao;
      this.$emit('change');
    },
  },
  created() {
    this.onlyPadrao = this.onlyPadrao || false;
  },
};
</script>
